import { Field } from 'module/api/field/types';
import { unreachable } from 'module/helpers/unreachable';
import {
  EstimateFieldFilter,
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from 'module/types/filter-field/filter/estimate';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';
import { getFieldValue } from './get-field-value';

export const estimate = (filter: EstimateFieldFilter): FilterFunction => {
  const value = getFieldValue<number | string>(filter.field as any as Field);

  /* Estimate field type is not an actual custom field type. In future if its needed, please handle the following conditions accordingly. */

  switch (filter.type) {
    case EstimateFieldFilterOperationType.IsMoreThan:
      return (record) => {
        const recordValue = Number(value(record));

        if (
          filter.days == null ||
          filter.direction == null ||
          recordValue == null
        ) {
          return false;
        }
        switch (filter.direction) {
          case EstimateRelativeDirection.Early:
            return (
              Number(recordValue) > 0 &&
              Math.abs(recordValue as number) > filter.days
            );
          case EstimateRelativeDirection.Late:
            return (
              Number(recordValue) < 0 &&
              Math.abs(recordValue as number) > filter.days
            );
          default:
            return unreachable(filter.direction);
        }
      };
    case EstimateFieldFilterOperationType.IsLessThan:
      return (record) => {
        const recordValue = value(record);

        if (
          filter.days == null ||
          filter.direction == null ||
          recordValue == null
        ) {
          return false;
        }
        switch (filter.direction) {
          case EstimateRelativeDirection.Early:
            return (
              Number(recordValue) > 0 &&
              Math.abs(recordValue as number) < filter.days
            );
          case EstimateRelativeDirection.Late:
            return (
              Number(recordValue) < 0 &&
              Math.abs(recordValue as number) < filter.days
            );
          default:
            return unreachable(filter.direction);
        }
      };
    default:
      return unreachable(filter);
  }
};
